/* eslint-disable no-useless-catch */
import { ENV } from "../utils";

export class Document {
  baseApi = ENV.BASE_API;

  async getDocuments(accessToken) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.DOCUMENT}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createDocument(accessToken, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.DOCUMENT}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateDocument(accessToken, documentId, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.DOCUMENT}/${documentId}`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteDocument(accessToken, documentId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.DOCUMENT}/${documentId}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}